import React from 'react';
import styles from "./statusHistoryDialog.module.scss";
import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import { StatusHistoryResponseData } from '../../../apis/models/StatusHistoryResponse';
import { InvStatus, StatusOptions } from '../../../libs/constants';
import { fromValToName } from '../../../libs/helpers';
import { format } from 'date-fns';


const StatusHistoryDialog: React.FC<StatusHistoryDialogProps> = (props: StatusHistoryDialogProps) => {
  const {open, onClose, data} = props;

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="lg">
      <DialogTitle sx={{ fontWeight: 700, fontSize: "24px", padding: "40px 40px 24px" }}>変更履歴</DialogTitle>
      <DialogContent sx={{ padding: "0 40px 24px" }}>
        <div className={styles.table__wrapper}>
          <table>
            <thead className={styles.table__head}>
              <tr>
                <th>変更日時</th>
                <th>担当者</th>
                <th>変更後ステータス</th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              {
                data && data.map((item, index) => (
                  <tr key={index}>
                    <td>{format(new Date(item.editedDate), "yyyy-MM-dd HH:mm")}</td>
                    <td>{item.staff}</td>
                    <td>
                      {
                        <span>
                          {
                            item.statusAfterChange === InvStatus.NOT_CONFIRMED ?
                            <img alt='pending_icon' src='/icons/pending_inv.svg'/> :
                            item.statusAfterChange === InvStatus.CONFIRMED ?
                            <img alt='confirmed_icon' src='/icons/confirmed_inv.svg'/> :
                            <img alt='exported_icon' src='/icons/exported_inv.svg'/>
                          }&nbsp;
                          {
                            fromValToName(StatusOptions, item.statusAfterChange)
                          }
                        </span>
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div className={styles.function}>
          <Button variant="outlined" color="primary" onClick={onClose}>閉じる</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default StatusHistoryDialog;

export type StatusHistoryDialogProps = {
  open: boolean,
  onClose: () => void,
  data: StatusHistoryResponseData[]
}